<div class="row row-wrapper {{ color }}">
  <img src="/logo.svg" alt="Logo von ideastream.io" />
  <span class="gebuk">ideastream.io</span>
</div>
